import { render, staticRenderFns } from "./SolGerencia.vue?vue&type=template&id=2aebf704&scoped=true&"
import script from "./SolGerencia.vue?vue&type=script&lang=js&"
export * from "./SolGerencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aebf704",
  null
  
)

export default component.exports